import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { TrasnferenciaCreditoClienteService } from 'src/app/admihair/service/transferencia-credito-cliente.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DetalheTransferenciaCreditoCliente } from 'src/app/admihair/api/dto/detalhe-transferencia-credito-cliente';

@Component({
  selector: 'app-transferencia-credito-cliente-janela',
  templateUrl: './transferencia-credito-cliente-janela.component.html',
  styleUrls: ['./transferencia-credito-cliente-janela.component.scss']
})
export class TransferenciaCreditoClienteJanelaComponent extends AdmihairBaseComponent implements OnInit {

  transferenciaCredito?: DetalheTransferenciaCreditoCliente;
  clienteId?: number;

  constructor(private transferenciaCreditoClienteService: TrasnferenciaCreditoClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {

    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.carregarIdUrl();
    this.carregar();
  }



  carregar() {
    this.transferenciaCreditoClienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: DetalheTransferenciaCreditoCliente) => {
        this.transferenciaCredito = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

}
